export default {"src":"/_next/static/media/login.53c1a016.svg","height":343,"width":433};